module.exports = __webpack_public_path__ + "static/media/Zgrada5.0ecc49da.png";